module.exports = __webpack_public_path__ + "img/1_hover.77ddeb01.png";